import React from 'react'
import './BlogBanner.css'
import About_Banner_Component from '../../about_us/about_banner/About_Banner_Component/About_Banner_Component'

const BlogBanner = () => {
    return (
        <section className='BlogBanner'>
            <About_Banner_Component
                img="\assets\Image\Blogs\banner.png"
                title="Stay Updated"
                subtext1="Your Financial Compass:"
                subtext2="Stay Updated and Navigate the Ever-Changing Money Landscape"
                showBtn={false}
            />
        </section>
    ) 
}

export default BlogBanner
